import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { AndFilter } from '../models/AndFilter';
import { FilterModel } from '../models/filter';
import { OrFilter } from '../models/OrFilter';
import { PointsService } from './points.service';
import { ProcedureModel } from '../models/procedure';


@Injectable({
  providedIn: 'root'
})
export class ProceduresService {

  informationMessage : string;

  constructor(
    private pointsController: PointsService,
  ){

  }

  filterProcedures(filters : FilterModel[], isFilter : boolean) {

		let numberOfProcedures : number = 0;

		let proceduresToRemove : Feature[] = [];

    let features : Feature[] = this.pointsController.getAllProceduresFeaturesFromLayers();

    features.forEach (proc => {
      numberOfProcedures++;
      proceduresToRemove.push(proc);
      proceduresToRemove = this.performFilter(proceduresToRemove, this.pointsController.transformFeatureInProcedure(proc), proc, filters);
    })

    if (isFilter){
      proceduresToRemove.forEach(nav => {
        numberOfProcedures--;
      });
      this.pointsController.deleteProceduresFeaturesFromMap(proceduresToRemove);
    }else {
      const filteredArray = features.filter(value => !proceduresToRemove.includes(value));

      filteredArray.forEach( navaid => {
        let layer : VectorLayerDMTR = this.pointsController.proceduresLayers.childLayers[0].layers.find((element) => element.id === navaid.getProperties().navaidtype.toLowerCase()).olLayer;
        navaid.setStyle(layer.getStyleSelected());
        this.pointsController.addSelectedFeature(navaid);
      })
    }
    this.informationMessage = "Displaying " + (features.length - proceduresToRemove.length) + " of " + features.length + ".";
		return numberOfProcedures;
	}

  performFilter(proceduresToRemove : Feature[], proc : ProcedureModel, feat : Feature, filters : FilterModel[]) : Feature[] {
		let iterator : number = 0;

		let orList : OrFilter[] = [];
		let andList : AndFilter[] = [];
		let toReturnOr : boolean = true;
		let toReturnAnd : boolean = true;

    filters.forEach( filter => {
      iterator++;

      let count : number = filters.filter( filter_aux => filter_aux.field == filter.field).length;
			let count_filter : number = orList.filter(filter_aux => filter_aux.getFilterName() == filter.field).length;

      if(count > 1) {
				if (count_filter > 0) {
					let filterValue : OrFilter  = orList.find(orfilter => orfilter.getFilterName() == filter.field)

					filterValue.addElement(this.filterByFields(proc, feat, filter));

				} else {
					let newOrFilter : OrFilter = new OrFilter(filter.field);
					newOrFilter.addElement(this.filterByFields(proc, feat, filter));
					orList.push(newOrFilter);
				}
			}else {

					let newAndFilter : AndFilter = new AndFilter(filter.field);
					newAndFilter.addElement(this.filterByFields(proc, feat, filter));
					andList.push(newAndFilter);
				}
    });

    orList.forEach( or => {
      toReturnOr = toReturnOr && or.getOrResult();
    })

    andList.forEach( and => {
      toReturnAnd = toReturnAnd && and.getOrResult();
    })

		if (toReturnOr && toReturnAnd) {
      const index = proceduresToRemove.indexOf(feat, 0);
      if (index > -1) {
        proceduresToRemove.splice(index, 1);
      }
		}


		return proceduresToRemove;
	}

  filterByFields(proc: ProcedureModel, feat: Feature, filter: FilterModel): boolean{
    let toReturn : boolean = false;

    switch(filter.field){
      case "Type":
        if (proc.proceduretype) {
          toReturn = this.toInternalTypeString(filter.value) === proc.proceduretype
        }
        break;
      case "RNAV Performance":
        if (proc.rnavperformancetype){
          toReturn = this.toInternalPerformanceString(filter.value) === (proc.rnavperformancetype);
        }
        break;
      case "Reference Airport":
        if (proc.referenceAirportPk){
          toReturn = filter.airportPk === (proc.referenceAirportPk);
        }
        break;
      default:
        toReturn= false;
        break;
    }
    return toReturn;
  }

  toInternalTypeString(value: String): String {
    const regEx = /[^a-zA-Z]+/gi;
    const internalValue = value.replace(regEx, "");

    return internalValue;
  }

  toInternalPerformanceString(value: String): String{
    let performanceType = "INVALID_PERFORMANCE";
    const regEx = /[^a-zA-Z]+/gi;
    const internalValue = value.replace(regEx, "");

    if (internalValue.includes("BRNAV"))
      performanceType = "B_RNAV";
    else if (internalValue.includes("PRNAV"))
     performanceType =  "P_RNAV";
    else if (internalValue.includes("ARNP"))
      performanceType = "A_RNP";

    return performanceType;
  }
}
